<template>
  <div class="flex flex-col">
    <label class="text-left block">
      <select class="
        w-full
        h-8
        rounded-md
        shadow
        border
        font-normal
        bg-white
        border-gray-300
        outline-none
        text-md
        text-black
        placeholder-gray-600"
        v-model="formValues"
        @blur="blurEvent()">
        <option
          v-for="item in syncStepOptions"
          :key="item.label"
          :value="item.value">
          {{ item.label }}
        </option>
      </select>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: undefined,
  },
  data() {
    return {
      edited: false,
      formValues: undefined,

      syncStepOptions: [
        { label: 'Sync Buildings', value: 'sync_building', },
        { label: 'Sync Students', value: 'sync_student', },
        { label: 'Sync Vehicles', value: 'sync_vehicle', },
        { label: 'Validate Students', value: 'validate_students', },
        { label: 'Pull Student Schedule', value: 'pull_student_schedule', },
      ],
    }
  },
  methods: {
    blurEvent() {
      this.edited = true
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
  },
  watch: {
    formValues() {
      this.updateValue()
    },
  }
}
</script>
